module.exports = __webpack_public_path__ + "static/media/me.be3b17db.svg";